import { render, staticRenderFns } from "./FCStaffExpansionPanel.vue?vue&type=template&id=ed512bca&scoped=true&"
import script from "./FCStaffExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./FCStaffExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./FCStaffExpansionPanel.vue?vue&type=style&index=0&id=ed512bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed512bca",
  null
  
)

export default component.exports